import { render, staticRenderFns } from "./FitPreferences.vue?vue&type=template&id=1894af6e"
import script from "./FitPreferences.vue?vue&type=script&lang=js"
export * from "./FitPreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports